import { type MCPServerInfo } from '../../types';

const MongodbServer: MCPServerInfo = {
  serverId: 'MONGODB',
  name: 'MongoDB',
  slug: 'mongodb',
  description:
    'A Model Context Protocol server to connect to MongoDB databases and MongoDB Atlas Clusters.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/mongodb:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: 'mongodb-mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['mdbMcpConnectionString'],
    properties: {
      mdbMcpConnectionString: {
        type: 'string',
        description: 'MongoDB connection string',
        sensitive: true
      }
    }
  }
};

export default MongodbServer;
